import { AvatarProps } from '../../components/avatar';
import { TextProps } from '../../components/text';
import { SpacingProps } from '../../components/box';

interface PersonDisplaySizes {
  avatar: AvatarProps['size'];
  title: Pick<TextProps, 'size' | 'weight'>;
  subtitle?: Pick<TextProps, 'size' | 'weight'>;
  textMarginLeft: SpacingProps['marginLeft'];
}

const sizes: {
  [key in NonNullable<AvatarProps['size']>]: PersonDisplaySizes;
} = {
  xxs: {
    avatar: 'xxs',
    title: {
      size: 'sm',
      weight: 400,
    },
    textMarginLeft: 'xs',
  },
  xs: {
    avatar: 'xs',
    title: {
      size: 'md',
      weight: 400,
    },
    subtitle: {
      size: 'sm',
    },
    textMarginLeft: 'xs',
  },
  sm: {
    avatar: 'sm',
    title: {
      size: 'md',
      weight: 500,
    },
    subtitle: {
      size: 'sm',
    },
    textMarginLeft: 'xs',
  },
  md: {
    avatar: 'md',
    title: {
      size: 'lg',
      weight: 500,
    },
    subtitle: {
      size: 'md',
      weight: 400,
    },
    textMarginLeft: 'xs',
  },
  lg: {
    avatar: 'lg',
    title: {
      size: 'xl',
      weight: 500,
    },
    subtitle: {
      size: 'md',
      weight: 400,
    },
    textMarginLeft: 'sm',
  },
  xl: {
    avatar: 'xl',
    title: {
      size: 'xl',
      weight: 500,
    },
    subtitle: {
      size: 'md',
      weight: 400,
    },
    textMarginLeft: 'sm',
  },
  xxl: {
    avatar: 'xxl',
    title: {
      size: 'xl',
      weight: 500,
    },
    subtitle: {
      size: 'md',
      weight: 400,
    },
    textMarginLeft: 'sm',
  },
};

export { sizes };
